import { DatasourceEnum } from "#/services/pilotService/types";
import { DatasetEnum } from "@inode/pilot-client-typescript-fetch";

type QueryExample = {
    nl: string;
    db: DatasourceEnum;
    /**
     * the query in its target language (i.e. sparql or sql)
     */
    ql?: string;
    source?: string;
    index?: string;
};
/**
 * From Tarcisio regarding oncomx
 *
 * The two 1st rows you have links to other data sheets containing hundreds of queries:
 * https://docs.google.com/spreadsheets/d/1mMqEURCAw8OMxRr1OPuvo_Ghjh6RSHz5FHp6ZblkDgg/edit?usp=sharing
 *
 * Note that in the gSpreadsheet doc (1 row link in the previous spreadsheet link) there are 3 pages with different NL-SQL queries.
 *
 * I am also putting the link here directly:
 * https://docs.google.com/spreadsheets/d/1P-940PumzfELYOKizltT3xy-2dBvyaEocWvngerbzZc/edit#gid=0
 *
 * There is the second row link at
 * https://docs.google.com/spreadsheets/d/1mMqEURCAw8OMxRr1OPuvo_Ghjh6RSHz5FHp6ZblkDgg/edit?usp=sharing
 * https://docs.google.com/spreadsheets/d/1P-940PumzfELYOKizltT3xy-2dBvyaEocWvngerbzZc/edit#gid=0
 * https://git.igd-r.fraunhofer.de/inode/oncomx-vkg/-/raw/master/current-version/no-federation/oncomx_demo_queries.txt
 * https://git.igd-r.fraunhofer.de/inode/oncomx-vkg/-/raw/master/current-version/no-federation/oncomx_demo_queries.txt
 *
 * This file was created for demo purposes of the use of Ontop over oncomx
 *
 * The one here with SQL queries contain several of them based on real user questions:
 * https://docs.google.com/spreadsheets/d/1P-940PumzfELYOKizltT3xy-2dBvyaEocWvngerbzZc/edit#gid=0
 *
 * Therefore they are more realistic I would say but the SPARQL equivalent was not done yet also because I am afraid of Ontop won’t handle them with a reasonable time or probably with some timeout
 * They are quite complex
 * Most of the time
 * See sheet: oncomx_workshop
 * Sheet: hello_world_queries contains “fake” queries for simplicity and testing to the NL tools otherwise we will only have wrong answers by using the realist (complex) queries
 *
 * Regarding SDSS:
 * better examples: https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit
 * not so perfect examples: https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=579320120
 * 2022-04-19: https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174
 *
 */
export const nlExamples: QueryExample[] = [
    {
        nl: "Project with acronym INODE",
        db: DatasourceEnum.cordis,
    },
    /* {
        nl: "Find all projects",
        db: DatasourceEnum.cordis,
    }, */
    {
        nl: "Projects that started after 2018",
        db: DatasourceEnum.cordis,
    },
    /* {
        nl: "Find projects that started before 2018",
        db: DatasourceEnum.cordis,
    },*/
    {
        nl: "Project members located in Italy",
        db: DatasourceEnum.cordis,
    },
    /*{
        nl: "Find projects where Alberto Broggi was involved",
        db: DatasourceEnum.cordis,
    },
    {
        nl: "How many projects started in 2016?",
        db: DatasourceEnum.cordis,
    },
    {
        nl: "What's the total cost of all projects?",
        db: DatasourceEnum.cordis,
    },
    {
        nl: "Find projects whose coordinator is from Greece",
        db: DatasourceEnum.cordis,
    },
    {
        nl: "Find the topics of projects that ended in 2014",
        db: DatasourceEnum.cordis,
    },
    {
        nl: "Find institutions that have acted as a coordinator",
        db: DatasourceEnum.cordis,
    },
    {
        nl: "Find projects with a member from Greece",
        db: DatasourceEnum.cordis,
    },
    {
        nl: "List all the members of project ALFRED",
        db: DatasourceEnum.cordis,
    },
    {
        nl: "List all projects under the FP7-ICT programme",
        db: DatasourceEnum.cordis,
    },
    {
        nl: "Find the role of ATHENA in project ARGOS",
        db: DatasourceEnum.cordis,
    },
    {
        nl: "Return all research organisations located in Greece",
        db: DatasourceEnum.cordis,
    },
    {
        nl: "Find all projects connected with institutes located in Schaffhausen area",
        db: DatasourceEnum.cordis,
    }, */
    {
        nl: "Project members from the city of Budapest with activity type HES",
        db: DatasourceEnum.cordis,
    },
    {
        nl: 'Projects of "Università di Pisa" ordered by year',
        db: DatasourceEnum.cordis,
    },
    {
        nl: 'Projects with programme short name "Biotechnology" and funding scheme code "SME-1"',
        db: DatasourceEnum.cordis,
    },
    {
        nl: "Institutions and sum of ec contribution in descending order",
        db: DatasourceEnum.cordis,
    },
    {
        nl: "Erc panel descriptions and sum of projects' ec contribution in descending order",
        db: DatasourceEnum.cordis,
    },
    {
        nl: 'Institutions that participate in projects with programme short name "Marie-Sklodowska-Curie Actions"',
        db: DatasourceEnum.cordis,
    },
    {
        nl: 'Projects of institutions with activity type PRC and programme short name "Nanotechnologies"',
        db: DatasourceEnum.cordis,
    },
    /* {
        nl: "Count the number of stars that are photometrically observed",
        db: DatasourceEnum.sdss,
    },
    {
        nl: "How many object were spectroscopically observed in the segue2 survey",
        db: DatasourceEnum.sdss,
    },
    {
        nl: "Find all photometrically observable galaxies",
        db: DatasourceEnum.sdss,
    },
    {
        nl: "Show all galaxies that have emission line estimates",
        db: DatasourceEnum.sdss,
    },
    {
        nl: "Find all photometrically observable stars",
        db: DatasourceEnum.sdss,
    }, */
    {
        nl: "cancer single biomarkers and their descriptions",
        db: DatasourceEnum.oncomx_sparql,
        index: "#QD01",
        source: "https://git.igd-r.fraunhofer.de/inode/oncomx-vkg/-/raw/master/current-version/no-federation/oncomx_demo_queries.txt",
    },
    {
        nl: "cancer single biomarkers for breast cancer",
        db: DatasourceEnum.oncomx_sparql,
        index: "#QD02:cancer single biomarkers for breast cancer",
        source: "https://git.igd-r.fraunhofer.de/inode/oncomx-vkg/-/raw/master/current-version/no-federation/oncomx_demo_queries.txt",
    },
    {
        nl: "cancer biomarker panels and their descriptions including indicated cancer type",
        db: DatasourceEnum.oncomx_sparql,
        index: "#QD03:cancer biomarker panels and their descriptions including indicated cancer type",
        source: "https://git.igd-r.fraunhofer.de/inode/oncomx-vkg/-/raw/master/current-version/no-federation/oncomx_demo_queries.txt",
    },
    {
        nl: "all cancer types in the database",
        db: DatasourceEnum.oncomx_sparql,
        index: "#QD04:all cancer types in the database",
        source: "https://git.igd-r.fraunhofer.de/inode/oncomx-vkg/-/raw/master/current-version/no-federation/oncomx_demo_queries.txt",
    },
    {
        nl: "all information about species in the database",
        db: DatasourceEnum.oncomx_sparql,
        index: "#QD05:all information about species in the database",
        source: "https://git.igd-r.fraunhofer.de/inode/oncomx-vkg/-/raw/master/current-version/no-federation/oncomx_demo_queries.txt",
    },
    {
        nl: "what are the cancer types where the A1BG gene expression is increased (up regulated)",
        db: DatasourceEnum.oncomx_sparql,
        index: "#QD06: what are the cancer types where the A1BG gene expression is increased (up regulated)",
        source: "https://git.igd-r.fraunhofer.de/inode/oncomx-vkg/-/raw/master/current-version/no-federation/oncomx_demo_queries.txt",
    },
    {
        nl: "what are the cancer types where the A1BG gene expression is statiscally significantly increased (up regulated)",
        db: DatasourceEnum.oncomx_sparql,
        index: "#QD07: what are the cancer types where the A1BG gene expression is statiscally significantly increased (up regulated)",
        source: "https://git.igd-r.fraunhofer.de/inode/oncomx-vkg/-/raw/master/current-version/no-federation/oncomx_demo_queries.txt",
    },
    {
        nl: "What are the healthy organs where the A1BG is expressed.",
        db: DatasourceEnum.oncomx_sparql,
        index: "#QD08: What are the healthy organs where the A1BG is expressed.",
        source: "https://git.igd-r.fraunhofer.de/inode/oncomx-vkg/-/raw/master/current-version/no-federation/oncomx_demo_queries.txt",
    },
    {
        db: DatasetEnum.sdss,
        source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
        nl: "Find all photometrically observed star",
        ql: "SELECT T1.objid FROM photoobj AS T1 JOIN photo_type AS T2 ON T1.type = T2.value WHERE T2.name = 'STAR'",
    },
    // {
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //     nl: "count objects that are photometrically observed star",
    //     ql: "SELECT count( T1.objid) FROM photoobj AS T1 JOIN photo_type AS T2 ON T1.type = T2.value WHERE T2.name = 'STAR'",
    // },
    {
        db: DatasetEnum.sdss,
        source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
        nl: "count photometric objects that are star",
        ql: "SELECT count(*) FROM photoobj AS T1 JOIN specobj AS T2 ON T1.objid = T2.bestobjid WHERE T2.class = 'STAR'",
    },
    // {
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //     nl: "count star",
    //     ql: "SELECT count(*) FROM specobj AS T1 WHERE T1.class = 'STAR'",
    // },
    // {
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //     nl: "Count the objects that are photometrically observed galaxy",
    //     ql: "SELECT count( T1.objid) FROM photoobj AS T1 JOIN photo_type AS T2 ON T1.type = T2.value WHERE T2.name = 'GALAXY'",
    // },
    // {
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //     nl: "Count the photometric objects that is galaxy",
    //     ql: "SELECT count(*) FROM photoobj AS T1 JOIN specobj AS T2 ON T1.objid = T2.bestobjid WHERE T2.class = 'GALAXY' OR SELECT count(*) FROM photoobj AS T1 JOIN photo_type AS T2 ON T1.type = T2.value WHERE T2.name = 'GALAXY' ",
    // },
    // {
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //     nl: "How many object were spectroscopically observed in the boss survey",
    //     ql: "SELECT count( T1.specobjid) FROM specobj AS T1 WHERE T1.survey = 'boss' OR SELECT count(*) FROM specobj AS T1 WHERE T1.survey = 'boss'",
    // },
    {
        db: DatasetEnum.sdss,
        source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
        nl: "Count objects spectroscopically observed in the Segue2 survey",
        ql: "SELECT count(*) FROM specobj AS T1 WHERE T1.survey = 'segue2' OR SELECT count( T1.specobjid) FROM specobj AS T1 WHERE T1.survey = 'segue2'",
    },
    // {
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //     nl: "How many objects were spectroscopically observed in the eboss survey",
    //     ql: "SELECT count(*) FROM specobj AS T1 WHERE T1.survey = 'eboss' OR SELECT count( T1.specobjid) FROM specobj AS T1 WHERE T1.survey = 'eboss'",
    // },
    //{
    //    db: DatasetEnum.sdss,
    //    source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //    nl: "Show all galaxy that have emission line estimates",
    //    ql: "SELECT T1.specobjid, T2.specobjid FROM galspecline AS T1 JOIN specobj AS T2 ON T1.specobjid = T2.specobjid",
    //},
    {
        db: DatasetEnum.sdss,
        source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
        nl: "Find all photometrically observable galaxy",
        ql: "SELECT T1.objid FROM photoobj AS T1 JOIN photo_type AS T2 ON T1.type = T2.value WHERE T2.name = 'GALAXY'",
    },
    {
        db: DatasetEnum.sdss,
        source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
        nl: "Find all photometric star that have spectral observations",
        ql: "SELECT T1.objid, T1.dec, T1.ra FROM photoobj AS T1 JOIN photo_type AS T2 ON T1.type = T2.value JOIN specobj AS T3 ON T1.objid = T3.bestobjid WHERE T2.name = 'STAR' and T3.class = 'STAR'",
    },
    // {
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //     nl: "Find all Galaxy that are active galactic nuclei AGN",
    //     ql: "SELECT T1.specobjid FROM specobj AS T1 WHERE T1.subclass = 'AGN' and T1.class = 'GALAXY'",
    // },
    // {
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //     nl: "Find all Galaxy that are Active galactic nuclei AGN BROADLINE",
    //     ql: "SELECT T1.specobjid FROM specobj AS T1 WHERE T1.subclass = 'AGN BROADLINE' and T1.class = 'GALAXY'",
    // },
    {
        db: DatasetEnum.sdss,
        source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
        nl: "Find all quasi stellar objects QSO",
        ql: "SELECT T1.specobjid FROM specobj AS T1 WHERE T1.class = 'QSO'",
    },
    {
        db: DatasetEnum.sdss,
        source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
        nl: "Find hot massive blue star of type OB",
        ql: "SELECT T1.specobjid FROM specobj AS T1 WHERE T1.subclass = 'OB' and T1.class like '%STAR%'",
    },
    {
        db: DatasetEnum.sdss,
        source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
        nl: "Find carbon star",
        ql: "SELECT T1.specobjid FROM specobj AS T1 WHERE T1.class = 'STAR' and T1.subclass = 'Carbon'",
    },
    // {
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //     nl: "Find white dwarf STAR (WD)",
    //     ql: "SELECT T1.specobjid FROM specobj AS T1 WHERE T1.class = 'STAR' and T1.subclass = 'WD'",
    // },
    // {
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //     nl: "Find photometric GALAXY whose magnitude r is brighter than 17 with the local extinction > 0.2",
    //     ql: "SELECT T1.objid FROM photoobj AS T1 JOIN photo_type AS T2 ON T1.type = T2.value WHERE T1.r < 17 and T1.extinction_r > 0.2 and T2.name = 'GALAXY'",
    // },
    // {
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //     nl: "Find Star of spectral type O",
    //     ql: "SELECT T1.specobjid, T1.subclass FROM specobj AS T1 WHERE T1.class = 'STAR' and T1.subclass like '%O%'",
    // },
    // {
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //     nl: "Find Star of spectral type 'B'",
    //     ql: "SELECT T1.specobjid, T1.subclass FROM specobj AS T1 WHERE T1.class = 'STAR' and T1.subclass like '%B%'",
    // },
    {
        db: DatasetEnum.sdss,
        source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
        nl: "Find Star of spectral type 'A'",
        ql: "SELECT T1.specobjid, T1.subclass FROM specobj AS T1 WHERE T1.class = 'STAR' and T1.subclass like '%A%'",
    },
    // {
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //     nl: "Find Star of spectral type 'F'",
    //     ql: "SELECT T1.specobjid, T1.subclass FROM specobj AS T1 WHERE T1.class = 'STAR' and T1.subclass like '%F%'",
    // },
    // {
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
    //     nl: "Find Star of spectral type 'G'",
    //     ql: "SELECT T1.specobjid, T1.subclass FROM specobj AS T1 WHERE T1.class = 'STAR' and T1.subclass like '%G%'",
    // },
    {
        db: DatasetEnum.sdss,
        source: "https://docs.google.com/spreadsheets/d/1Aq6FlzXcn6K3hsieHT3tlDCkSvmhjTmn1-l0KWNsK5k/edit#gid=987418174",
        nl: "Find cataclysmic variable Star of spectral type CV",
        ql: "SELECT T1.specobjid FROM specobj AS T1 WHERE T1.class = 'STAR' and T1.subclass = 'CV'",
    },
    // {
    //     nl: "select all stars from Photoobj",
    //     ql: "select p.objid, p.ra, p.dec, p.type from photoobj as P WHERE p.type = 6 limit 10",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "To select all stars from Photoobj table, that have spectral observations (JOIN Specobj table):",
    //     ql: "select p.objid, p.ra, p.dec, p.type, s.z, s.specclass from photoobj as p join specobj as s on s.objid=p.objid WHERE s.specclass=1 limit 10",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find all type 2 Active galactic nuclei",
    //     ql: "SELECT s.specobjid, s.class, s.subclass FROM SpecObj as s WHERE s.subclass = 'AGN' AND s.class= 'GALAXY'",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find all type 1 Active galactic nuclei",
    //     ql: "SELECT s.specobjid FROM SpecObj as s WHERE s.subclass = 'AGN BROADLINE' AND s.class= 'GALAXY'",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find all quasi stellar objects or QSOs",
    //     ql: "SELECT specobjid FROM SpecObj WHERE class = 'QSO'",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find hot massive blue stars or star type OB",
    //     ql: "SELECT s.specobjid FROM SpecObj as s WHERE s.subclass = 'OB' AND s.class= 'STAR'",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find carbon stars, stars that are at the end of their life.",
    //     ql: "SELECT s.specobjid FROM SpecObj as s WHERE s.class='STAR' AND s.subclass='Carbon' OR s.subclass='Carbon_lines'",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find White dwarfs",
    //     ql: "SELECT s.specobjid,s.bestobjid, s.class, s.subclass, s.programname,s.survey FROM SpecObj as s WHERE s.class='STAR' AND substring(s.subclass,1,2) = 'WD'",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find hot massive blue stars",
    //     ql: "SELECT s.specobjid, s.subclass FROM SpecObj as s WHERE s.class='STAR' AND substring(s.subclass,1,1) = 'O'",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find stars of spectral type O",
    //     ql: "SELECT s.specobjid, s.subclass FROM SpecObj as s WHERE s.class='STAR' AND substring(s.subclass,1,1) = 'O'",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find the hottest stars",
    //     ql: "SELECT s.specobjid, s.subclass FROM SpecObj as s WHERE s.class='STAR' AND substring(s.subclass,1,1) = 'O'",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find luminous blue white stars",
    //     ql: "SELECT s.specobjid, s.subclass FROM SpecObj as s WHERE s.class='STAR' AND substring(s.subclass,1,1) = 'B'",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "find stars of spectral type B",
    //     ql: "SELECT s.specobjid, s.subclass FROM SpecObj as s WHERE s.class='STAR' AND substring(s.subclass,1,1) = 'B'",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find moving Asteroids from photometric data",
    //     ql: " SELECT TOP 5 objID, ra, dec, sqrt( power(rowv,2) + power(colv, 2) ) as velocity FROM PhotoObj WHERE (power(rowv,2) + power(colv, 2)) > 50 AND rowv <> -9999 and colv <> -9999",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find Cataclysmic Variables from photometry",
    //     ql: "SELECT S1.objID as objid FROM photoobj AS S1 WHERE S1.type = 6 and ((S1.u - S1.g) < 0.4 ) and (S1.g - S1.r) < 0.7 and (S1.r - S1.i) > 0.4 and (S1.i - S1.z) > 0.4",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find Cataclysmic Variables using Paulo Szkody color cut",
    //     ql: "SELECT S1.objID as objid FROM photoobj AS S1 WHERE S1.type = 6 and ((S1.u - S1.g) < 0.4 ) and (S1.g - S1.r) < 0.7 and (S1.r - S1.i) > 0.4 and (S1.i - S1.z) > 0.4",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find Binary star systems with a white dwarf primary and a mass transferring secondary star",
    //     ql: "SELECT s1.objID as pobjid, s2.objid as s2objid FROM photoobj as s1 JOIN neighbors AS N ON s1.objID = N.objID JOIN photoobj AS S2 ON S2.objID = N.NeighborObjID WHERE s1.type = 6 and s2.type = 6 AND N.neighbortype = 6 and N.distance < .05 AND ((S1.u - S1.g) < 0.4 ) and (S1.g - S1.r) < 0.7 AND (S1.r - S1.i) > 0.4 and (S1.i - S1.z) > 0.4",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find Binary system with a white dwarf primary using Paula Szkody color cut",
    //     ql: "SELECT s1.objID as pobjid, s2.objid as s2objid FROM photoobj as s1 JOIN neighbors AS N ON s1.objID = N.objID JOIN photoobj AS S2 ON S2.objID = N.NeighborObjID WHERE s1.type = 6 and s2.type = 6 AND N.neighbortype = 6 and N.distance < .05 AND ((S1.u - S1.g) < 0.4 ) and (S1.g - S1.r) < 0.7 AND (S1.r - S1.i) > 0.4 and (S1.i - S1.z) > 0.4",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find Galaxies that are brighter than r magnitude 17 with the local extinction > 0.2",
    //     ql: "SELECT count(*) FROM Photoobj WHERE r < 17 AND extinction_r > 0.2 AND Type = 3",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find galaxies within certain area of the sky using spatial unit vectors (cx, cy) for coordinate cuts",
    //     ql: "SELECT TOP 100 colc_g, colc_r FROM photoobj WHERE type=3 and (-0.466 * cx + 0.689 * cy>=0) and (-0.385 * cx - 0.173 * cy <0)",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find Low redshift QSO candidates using color cuts",
    //     ql: "SELECT TOP 1000 objID, g FROM Photoobj WHERE type=3 and (g <= 22) and (u-g >= -0.27) and (u-g < 0.71) And (g-r >= -0.24) and (g-r < 0.35) and (r-i >= -0.27) and (r-i < 0.57) and (i-z >= -0.35) and (i-z < 0.70))",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find quasars in imaging data",
    //     ql: "SELECT TOP 10 objID, ra, dec FROM Photoobj WHERE type = 6 And ( u - g > 2.0 or u > 22.3 ) and ( i < 19 ) and ( i > 0 ) and ( g - r > 1.0 ) and ( r - i < (0.08 + 0.42 * (g - r - 0.96) ) or g - r > 2.26 ) and ( i - z < 0.25 )",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find neighbours within 30 arcseconds of one another that have very similar colors",
    //     ql: "SELECT TOP 10 P.ObjID as objid1, L.ObjID as objid2, N.distance FROM Photoobj P JOIN Neighbors N ON P.ObjID = N.ObjID JOIN Photoobj L ON L.ObjID = N.NeighborObjID WHERE P.mode=1 and P.ObjID < L. ObjID and abs((P.u-P.g)-(L.u-L.g))<0.05 and abs((P.g-P.r)-(L.g-L.r))<0.05 and abs((P.r-P.i)-(L.r-L.i))<0.05 and abs((P.i-P.z)-(L.i-L.z))<0.05",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find Luminous Red Galaxies (LRGs)",
    //     ql: "SELECT TOP 10 objID, ra, dec FROM Photoobj WHERE mode = 1 and type = 3 and ( ( flags & (dbo.fPhotoFlags('BINNED1') + dbo.fPhotoFlags('BINNED2') + dbo.fPhotoFlags('BINNED4')) ) > 0 and ( flags & (dbo.fPhotoFlags('BLENDED') + dbo.fPhotoFlags('NODEBLEND') + dbo.fPhotoFlags('CHILD')) ) != dbo.fPhotoFlags('BLENDED') and ( flags & (dbo.fPhotoFlags('EDGE') + dbo.fPhotoFlags('SATURATED')) ) = 0 and petroMag_i > 17.5 and (petroMag_r > 15.5 or petror50_r > 2) and (petroMag_r > 0 and g > 0 and r > 0 and i > 0) and ( (petroMag_r-extinction_r) < 19.2 and (petroMag_r - extinction_r < (13.1 + (7/3) * (dered_g - dered_r) + 4 * (dered_r - dered_i) - 4 * 0.18) ) and ( (dered_r - dered_i - (dered_g - dered_r)/4 - 0.18) < 0.2) and ( (dered_r - dered_i - (dered_g - dered_r)/4 - 0.18) > -0.2) and ( (petroMag_r - extinction_r + 2.5 * LOG10(2 * 3.1415 * petror50_r * petror50_r)) < 24.2) ) or ( (petroMag_r - extinction_r < 19.5) and ( (dered_r - dered_i - (dered_g - dered_r)/4 - 0.18) > (0.45 - 4 * (dered_g - dered_r)) ) and ( (dered_g - dered_r) > (1.35 + 0.25 * (dered_r - dered_i)) ) ) and ( (petroMag_r - extinction_r + 2.5 * LOG10(2 * 3.1415 * petror50_r * petror50_r) ) < 23.3 ) )",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find quasars with a broad absorption line and a nearby galaxy within 10 arcseconds.",
    //     ql: "SELECT Q.BestObjID as Quasar_candidate_ID , G.ObjID as Galaxy_ID, N.distance FROM SpecObj as Q, Neighbors as N,Galaxy as G, SpecClass as SC, SpecLine as L, SpecLineNames as LN WHERE Q.SpecClass =SC.value and SC.name in ('QSO', 'HIZ_QSO') and Q.SpecObjID = L.SpecObjID and L.LineID = LN.value and LN.Name != 'UNKNOWN' and L.ew < -10 and Q.BestObjID = N.ObjID and G.ObjID = N.NeighborObjID and N.distance < 10.0/60",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find near Brightest Cluster Galaxy",
    //     ql: "SELECT G.objID, count(N.NeighborObjID) as pop FROM Galaxy as G, Neighbors as N, Galaxy as U,photoZ as Gpz, photoZ as Npz WHERE G.ra between 160 and 170 and G.dec between -5 and 5 and G.objID = N.objID and U.objID = N.neighborObjID and N.objID < N.neighborObjID and G.objID = Gpz.objID and U.objID = Npz.objID and abs(Gpz.Z - Npz.Z) < 0.05 and (G.flags & (dbo.fPhotoFlags('BINNED1') + dbo.fPhotoFlags('BINNED2') + dbo.fPhotoFlags('BINNED4'))) > 0 --and it is detected from at least one of the binned images and (G.flags & ( dbo.fPhotoFlags('BLENDED') + dbo.fPhotoFlags('NODEBLEND') + dbo.fPhotoFlags('CHILD'))) != dbo.fPhotoFlags('BLENDED') --and, if it is blended, it is either a child or not deblended further ?? and (G.flags & (dbo.fPhotoFlags('EDGE') + dbo.fPhotoFlags('SATURATED'))) = 0 and G.petroMag_i > 17.5 and (G.petroMag_r > 15.5 or G.petror50_r > 2) and (G.petroMag_r < 30 and G.g < 30 and G.r < 30 and G.i < 30) and (G.r < 19.2 and ( 1=1 or (G.r < (13.1 + (7/3)*(G.g - G.r) + 4 *(G.r - G.i - 0.18 )) and (( G.r - G.i - (G.g - G.r)/4 - 0.18) BETWEEN -0.2 and 0.2 ) and ((G.r + 2.5 * LOG( 2 * 3.1415 * G.petror50_r * G.petror50_r )) < 24.2 ) ) or ( (G.r < 19.5 ) and (( G.r - G.i -(G.g - G.r)/4 -.18) > (0.45 - 4*( G.g - G.r))) and ((G.g - G.r) > ( 1.35 + 0.25 *(G.r - G.i))) and ((G.r + 2.5 * LOG( 2 * 3.1415 * G.petror50_r * G.petror50_r )) < 23.3 ) )) ) group by G.objID",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    // {
    //     nl: "Find galaxies that are blended with a star and output the deblended galaxy magnitudes.",
    //     ql: "SELECT P.objid, P.u, P.g, P.r, P.i, P.z FROM photoobj as P1 FROM photoobj as P2 WHERE P1.type = 3 and P2.type = 6 AND P1.parentID > 0 AND P1.parentID = P2.parentid",
    //     db: DatasetEnum.sdss,
    //     source: "https://docs.google.com/document/d/11EduGpXIFenmiFqZTuod-O8cqI_YIxi47jYG0rEFUt4/edit",
    // },
    {
        db: DatasourceEnum.oncomx,
        nl: "Show all gene symbols in differential expression",
    },
    {
        db: DatasourceEnum.oncomx,
        nl: "all information about species in the database",
    },
    {
        db: DatasourceEnum.oncomx,
        nl: "Show the gene symbol and the description of biomarkers",
    },
    {
        db: DatasourceEnum.oncomx,
        nl: "Show biomarker drugs",
    },
    {
        db: DatasourceEnum.oncomx,
        nl: "Show me the name of anatomical entities",
    },
    {
        db: DatasourceEnum.oncomx,
        nl: "List all disease names",
    },
    {
        db: DatasourceEnum.oncomx,
        nl: "Show all information about stages",
    },
    {
        db: DatasourceEnum.oncomx,
        nl: "Show distinct manufacturer of tests for gene BRAF",
    },
    {
        db: DatasourceEnum.oncomx,
        nl: "Show all information about disease mutations of lung cancer",
    },
    {
        db: DatasourceEnum.oncomx,
        nl: "Show all information about differential expression of lung cancer",
    },
    {
        db: DatasourceEnum.cordis_sparql,
        nl: "Show EC-Projects that have started in 2014",
    },
    {
        db: DatasourceEnum.cordis_sparql,
        nl: "Show the end year of the Project named Theseus",
    },
    {
        db: DatasourceEnum.world_cup,
        nl: "Show the player names of team France from 2022",
    },
];
